module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/CartImg.9b9787b2.svg";